(() => {
  function addTwoPageExploreCard() {
    const section = document.querySelector('[id^="ProductExploreMore-"]');
    if (!section || section.dataset.twoPageCardAdded === 'true') return;

    const grid = section.querySelector('.product-explore-more__grid');
    const sourceCard = grid?.querySelector(
      '.product-explore-more-card--default-page, .product-explore-more-card--page'
    );

    if (!grid || !sourceCard) return;
    if (grid.querySelector('a[href="/pages/2page"], a[href$="/pages/2page"]')) return;

    section.style.setProperty('--product-explore-more-column-gap', '8px');

    const card = sourceCard.cloneNode(true);

    if (card instanceof HTMLAnchorElement) {
      card.href = '/pages/2page';
    }

    card.classList.remove('product-explore-more-card--default-page');
    card.classList.add('product-explore-more-card--2page');

    const title = card.querySelector('.product-explore-more-card__title');
    if (title) title.textContent = '2PAGE';

    const subtitle = card.querySelector('.product-explore-more-card__subtitle');
    if (subtitle) subtitle.textContent = '';

    sourceCard.insertAdjacentElement('afterend', card);
    section.dataset.twoPageCardAdded = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addTwoPageExploreCard, { once: true });
  } else {
    addTwoPageExploreCard();
  }

  document.addEventListener('shopify:section:load', addTwoPageExploreCard);
})();
